<div class="cl-device-input" fxFlex *ngIf="deviceInput.isVisible">
    <label class="text-contrast">{{ deviceInput.displayText }}</label>

    <div>
        <mat-form-field appearance="outline">
            <input class="text-contrast" matInput #ref [matDatepicker]="datepicker" placeholder="Enter Date" [formControl]="datepickerFormControl" (dateChange)="onDateUpdate(ref.value)"/>
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker></mat-datepicker>
            <mat-error *ngIf="datepickerFormControl.touched && datepickerFormControl.invalid">Date is required!</mat-error>
        </mat-form-field>

        <cl-split-time-input [formGroup]="deviceInputForm" [isDisabled]="!deviceInput.isEnabled" [format]="timeFormat" [value]="time" [minValue]="timeMinValue" [maxValue]="timeMaxValue" (onUpdate)="onTimeUpdate($event)" unit="seconds">
        </cl-split-time-input>
    </div>


</div>
